export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const GET_PROFILE = 'GET_PROFILE';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const PROFILE_ERROR = 'PROFILE_ERROR';
export const CREATE_INIT_PROFILE = 'CREATE_INIT_PROFILE';
export const ADD_EXPERIENCE = 'ADD_EXPERIENCE';
export const DELETE_EXPERIENCE = 'DELETE_EXPERIENCE';
export const PUT_EXPERIENCE = 'PUT_EXPERIENCE';
export const ADD_EDUCATION = 'ADD_EDUCATION';
export const PUT_EDUCATION = 'PUT_EDUCATION';
export const DELETE_EDUCATION = 'DELETE_EDUCATION';
export const CLEAR_PROFILE = 'CLEAR_PROFILE';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const FETCH_POST = 'FETCH_POST';
export const BOOKMARK_POST = 'BOOKMARK_POST';
export const UNBOOKMARK_POST = 'UNBOOKMARK_POST';
